import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/get-built-in.js";
import "../internals/promise-native-constructor.js";
import { p as s } from "../internals/promise-constructor-detection.js";
import { p as o } from "../internals/promise-resolve.js";
var e = s.CONSTRUCTOR;
t("Promise"), r({
  target: "Promise",
  stat: !0,
  forced: e
}, {
  resolve: function resolve(r) {
    return o(this, r);
  }
});